import clsx from "clsx";
import React, { useEffect, useState, useRef } from "react";
import "./Nav.scss";
import HamburgerMenu from "../MobileNav/HamburgerMenu";
import MobileNav from "../MobileNav/MobileNav";
import Logo from "./Logo/Logo";
import { ReactComponent as LogoIcon } from "../../../assets/shared/logo.svg";
import { ReactComponent as Logoblack } from "../../../assets/shared/logoblack.svg";

function Nav(props) {
  const [isSticky, setIsSticky] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [changeColor, setChangeColor] = useState(false);
  const [changeColorContact, setChangeColorContact] = useState(false);

  useEffect(() => {
    const nav = document.querySelector(".nav");
    const navHeight = nav.scrollHeight;

    const handleScroll = () => {
      setScrollY(window.scrollY);

      // if (scrollY > 2200) {
      //   setChangeColor(true);
      // }
      // if (scrollY > 7050) {
      //   setChangeColor(false);
      // }
      // if (scrollY > 8000) {
      //   setChangeColor(true);
      // }

      if (scrollY >= 0 && scrollY <= 2200) {
        setChangeColor(false);
      } else if (scrollY >= 2200 && scrollY <= 7030) {
        setChangeColor(true);
      } else if (scrollY >= 7030 && scrollY <= 8000) {
        setChangeColor(false);
      } else if (scrollY >= 8000) {
        setChangeColor(true);
      }

      if (scrollY >= 0 && scrollY <= 700) {
        setChangeColorContact(false);
      } else {
        setChangeColorContact(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollY]);

  // const [isSticky, setIsSticky] = useState(false);
  // const [scrollY, setScrollY] = useState(0);
  // const [changeColor, setChangeColor] = useState(false);

  // useEffect(() => {
  //   const nav = document.querySelector(".nav");
  //   const navHeight = nav.scrollHeight;
  //   const scrollY = window.pageYOffset;
  //   const handleScroll = () => {
  //     const scrollHeight = window.pageYOffset;
  //     setIsSticky(scrollHeight > 0.1 ? true : false);
  //   };
  //   window.addEventListener("scroll", handleScroll);

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  // window.onscroll = () => {
  //   setScrollY(window.scrollY);

  //   if (scrollY > 2200) {
  //     setChangeColor(true);
  //   }
  //   if (scrollY > 7050) {
  //     setChangeColor(false);
  //   }
  //   if (scrollY > 8000) {
  //     setChangeColor(true);
  //   }
  // };

  // console.log(scrollY);
  // console.log(changeColorContact);

  return (
    <nav
      className={clsx(
        "nav",
        clsx(props.styles),
        scrollY > 0.1 && clsx("nav__isWhite"),
        scrollY > 600 && clsx("nav__difColor")
      )}
    >
      <div className="left-side">
        {props.changeLogo ? (
          <Logo
            logo={changeColor === true ? <Logoblack /> : <LogoIcon />}
            className={changeColor === true ? "stickyColor" : "normalColor"}
          />
        ) : null}

        

        {/* {scrollY} */}
      </div>
      <div className="right-side">
        <MobileNav />
        <HamburgerMenu />
      </div>
    </nav>
  );
}

export default Nav;
